import React from 'react';
import { Section } from './ui/Section';
import { MapPin, Clock, CheckCircle, DollarSign } from 'lucide-react';
const features = [{
  icon: <MapPin className="h-6 w-6" data-id="element-166" data-mp="13wp5vco5vrr7" />,
  title: 'Local & Licensed',
  description: "Based in PDX, fully licensed, bonded, and insured (CCB# 227677). We're your neighbors."
}, {
  icon: <Clock className="h-6 w-6" data-id="element-167" data-mp="u5uksbmniy7c" />,
  title: 'Fast Response',
  description: 'We actually answer the phone and show up when we say we will. Respecting your time is our priority.'
}, {
  icon: <CheckCircle className="h-6 w-6" data-id="element-168" data-mp="l8ahyy954tum" />,
  title: 'Quality Work',
  description: 'We take pride in craftsmanship. No cutting corners, just solid work that lasts.'
}, {
  icon: <DollarSign className="h-6 w-6" data-id="element-169" data-mp="b9b8jdgjwu6k" />,
  title: 'Fair Pricing',
  description: "Transparent estimates with no hidden fees. You'll know exactly what you're paying for."
}];
export function WhyChooseUs() {
  return <Section id="why-us" background="primary" className="relative overflow-hidden bg-[#17a2b8]" data-id="element-170" data-mp="25kgh8w6hvwsr">
      {/* Texture overlay */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: `radial-gradient(#ffffff 1px, transparent 1px)`,
      backgroundSize: '24px 24px'
    }} data-id="element-171" data-mp="1igbxwp05nr27" />

      <div className="relative z-10" data-id="element-172" data-mp="1s6oiuibvtm8v">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-173" data-mp="1s7puop0q2crn">
          <div data-id="element-174" data-mp="14gkiqkxwk4mm">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-175" data-mp="14g187pal0iim">
              Why Portland Homeowners and Businesses Trust Us
            </h2>
            <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-176" data-mp="1ee8mu1heeohg">
              Finding a contractor for jobs can be frustrating. We're changing
              that by bringing professional standards to maintenance, repairs
              and remodels.
            </p>

            <div className="grid sm:grid-cols-2 gap-8" data-id="element-177" data-mp="2ku15esi1lu26">
              {features.map((feature, index) => <div key={index} className="flex flex-col gap-3" data-id="element-178" data-mp="2rxhe75y5sjgr" data-mpi={index}>
                  <div className="w-12 h-12 rounded-lg bg-white/10 flex items-center justify-center text-[#ff6b35] backdrop-blur-sm" data-id="element-179" data-mp="2rzbozrfpuv74">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-bold text-white" data-id="element-180" data-mp="31w6r0kb77dq5">
                    {feature.title}
                  </h3>
                  <p className="text-white/70 text-sm leading-relaxed" data-id="element-181" data-mp="296rdnnw298r2">
                    {feature.description}
                  </p>
                </div>)}
            </div>
          </div>

          <div className="hidden lg:block relative" data-id="element-182" data-mp="2j4xavs6x9qpl">
            <div className="bg-[#faf8f5] p-8 rounded-2xl shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-183" data-mp="2j3ck8dnqarx0">
              <div className="flex flex-col gap-6" data-id="element-184" data-mp="1qg9lbkf54f68">
                <div className="flex items-center gap-4 border-b border-gray-200 pb-4" data-id="element-185" data-mp="1qfgll3elmpxl">
                  <div className="h-12 w-12 bg-gray-200 rounded-full flex items-center justify-center text-xl font-bold text-gray-500" data-id="element-186" data-mp="1veb8agfosymz">
                    JS
                  </div>
                  <div data-id="element-187" data-mp="8idagfdq6qcr">
                    <div className="font-bold text-[#2c2c2c]" data-id="element-188" data-mp="8jy31zghbz7z">Jennifer S.</div>
                    <div className="text-sm text-gray-500" data-id="element-189" data-mp="3iquvzafcy0s">NE Portland</div>
                  </div>
                  <div className="ml-auto flex text-yellow-400" data-id="element-190" data-mp="3uqmqhl1r1hpz">{'★★★★★'}</div>
                </div>
                <p className="text-[#525252] italic" data-id="element-191" data-mp="3pr0dncpu23hp">
                  "Finally found a contractor who calls back! Fix & Finish
                  handled our list of repairs in one day. The work was perfect
                  and they left the place cleaner than they found it."
                </p>
              </div>
            </div>

            <div className="bg-[#faf8f5] p-8 rounded-2xl shadow-2xl transform -rotate-2 hover:rotate-0 transition-transform duration-500 mt-8 translate-x-8" data-id="element-192" data-mp="3c16kwjb7iz2p">
              <div className="flex flex-col gap-6" data-id="element-193" data-mp="320w7oyp69rnj">
                <div className="flex items-center gap-4 border-b border-gray-200 pb-4" data-id="element-194" data-mp="323idotwezz3n">
                  <div className="h-12 w-12 bg-gray-200 rounded-full flex items-center justify-center text-xl font-bold text-gray-500" data-id="element-195" data-mp="16048cp1jb24a">
                    MR
                  </div>
                  <div data-id="element-196" data-mp="w7ootnala5ha">
                    <div className="font-bold text-[#2c2c2c]" data-id="element-197" data-mp="w6dmzt0pf7st">Mike R.</div>
                    <div className="text-sm text-gray-500" data-id="element-198" data-mp="115q9gcnnycuv">Beaverton</div>
                  </div>
                  <div className="ml-auto flex text-yellow-400" data-id="element-199" data-mp="n5yott2n5y7w">{'★★★★★'}</div>
                </div>
                <p className="text-[#525252] italic" data-id="element-200" data-mp="s87hspfil0a0">
                  "Honest pricing and great communication. They fixed a leak
                  that two other handymen couldn't figure out. Highly
                  recommended."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}